import React from 'react';
import { getStudentData } from '../assets/data';
import defaultCover from '../assets/novas-banner-template.jpeg';
import './LessonCard.css';

function mapCEFRToLabel(code) {
  if (!code) return '';
  const c = String(code).toUpperCase();
  if (c === 'A1' || c === 'A2') return 'Beginner';
  if (c === 'B1' || c === 'B2') return 'Intermediate';
  if (c === 'C1' || c === 'C2') return 'Advanced';
  return c;
}

function buildDisplayTags(lesson) {
  if (Array.isArray(lesson.tags) && lesson.tags.length) return lesson.tags;
  const topics = Array.isArray(lesson.topics) ? lesson.topics : [];
  const cefr = Array.isArray(lesson.cefrLevels) ? Array.from(new Set(lesson.cefrLevels.map(mapCEFRToLabel))) : [];
  const medium = lesson.medium ? [String(lesson.medium).charAt(0).toUpperCase() + String(lesson.medium).slice(1)] : [];
  return [...topics, ...cefr, ...medium].filter(Boolean);
}

export default function LessonCard({ lesson }) {
  const resolveCover = (l) => {
    const banners = l && typeof l.docBanners === 'object' && l.docBanners !== null ? Object.values(l.docBanners).filter(Boolean) : [];
    return (
      l?.cover ||
      l?.bannerImage ||
      l?.imageUrl ||
      (banners.length ? banners[0] : '') ||
      defaultCover
    );
  };
  const cover = resolveCover(lesson);
  const resolveStudentName = (l) => {
    if (!l) return '';
    if (l.studentName && String(l.studentName).trim()) return String(l.studentName).trim();
    if (l.student && (l.student.name || l.student.title)) return l.student.name || l.student.title;
    if (l.studentId) {
      try {
        const all = getStudentData && getStudentData();
        const s = all ? all[String(l.studentId)] : undefined;
        if (s && s.name) return s.name;
      } catch (_) {}
    }
    return '';
  };
  const studentName = resolveStudentName(lesson);
  const splitTitleBy31 = (title) => {
    const text = String(title || '');
    const limit = 31;
    if (text.length <= limit) return [text];
    const before = text.lastIndexOf(' ', limit);
    if (before > 0) {
      return [text.slice(0, before), text.slice(before + 1)];
    }
    const after = text.indexOf(' ', limit);
    if (after > 0) {
      return [text.slice(0, after), text.slice(after + 1)];
    }
    return [text.slice(0, limit), text.slice(limit)];
  };
  const [t1, t2] = splitTitleBy31(lesson.title);
  const displayTags = buildDisplayTags(lesson);
  return (
    <div className="lesson-card">
      <div 
        className="card-background" 
        style={{ backgroundImage: cover ? `url(${cover})` : 'none' }}
      />
      <div className="card-overlay" />
      <div className="card-content">
        {studentName ? (
          <div className="student-badge">{studentName}</div>
        ) : null}
        <div className="card-tags">
          {displayTags.map(tag => (
            <span key={tag} className="tag">{tag}</span>
          ))}
        </div>
        <div className="card-body">
          <div className="card-title">
            <h2>
              {t2 ? (
                <>
                  <span>{t1}</span><br />
                  <span>{t2}</span>
                </>
              ) : t1}
            </h2>
          </div>
          <p className="card-description">{lesson.description}</p>
        </div>
      </div>
    </div>
  );
}


